import { __decorate, __metadata } from "tslib";
import { AppRequest } from '@core/shared/app-request';
import { AppRequestMethod } from '@core/shared/request';
import { usernameOrEmailUserItemValidator } from '@common/users/shared/validators';
import { ConfiguratedValidator, Default, EditorDefinition, Expose, IsMatching, IsSafePassword, MinLength, Model, ModelId } from '@core/shared/model';
let PasswordResetRequest = /*#__PURE__*/(() => {
  let PasswordResetRequest = class PasswordResetRequest extends Model {};
  __decorate([Expose(), MinLength(3), ConfiguratedValidator(usernameOrEmailUserItemValidator), __metadata("design:type", String)], PasswordResetRequest.prototype, "username", void 0);
  __decorate([IsSafePassword(), Expose(), Default(''), __metadata("design:type", String)], PasswordResetRequest.prototype, "password", void 0);
  __decorate([Expose(), Default(''), IsMatching('password'), __metadata("design:type", String)], PasswordResetRequest.prototype, "password2", void 0);
  __decorate([Expose(), MinLength(16), __metadata("design:type", String)], PasswordResetRequest.prototype, "token", void 0);
  PasswordResetRequest = __decorate([AppRequest('users', 'password-reset/reset', {
    httpMethod: AppRequestMethod.POST
  }), EditorDefinition([], {
    allowAllExposed: true,
    useAppRequest: true
  }), ModelId("PasswordResetRequest") // auto-generated by generate-model-ids
  ], PasswordResetRequest);
  return PasswordResetRequest;
})();
export { PasswordResetRequest };